'use client';

import { memo } from 'react';
import TrailingLink from '@/components/atoms/TrailingLink';
import styles from './Breadcrumb.module.scss';

export interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  separator?: string;
}

export const Breadcrumb = memo(({
  items,
  className = '',
  separator = '›'
}: BreadcrumbProps) => {
  if (!items || items.length === 0) {
    return null;
  }
  
  return (
    <nav 
      className={`${styles.breadcrumb} ${className}`}
      aria-label="パンくずリスト"
    >
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          
          return (
            <li 
              key={index} 
              className={`${styles.item} ${isLast ? styles.current : ''}`}
            >
              {item.href && !isLast ? (
                <TrailingLink 
                  href={item.href}
                  className={styles.link}
                >
                  {item.label}
                </TrailingLink>
              ) : (
                <span 
                  className={styles.text}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
              
              {!isLast && (
                <span 
                  className={styles.separator}
                  aria-hidden="true"
                >
                  {separator}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
});

export default Breadcrumb;